import {ChangeEvent, FC, FormEventHandler, useState} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'
import {useRouter} from 'next/router'

import Input from 'components/elements/fields/Input'
import IconSearch from 'public/icons/search.svg'
import Button from 'src/components/elements/Button'

import s from './BlogSearch.module.scss'
const cx = cn.bind(s)

interface IBlogSearchProps {
	className?: string
	placeholder?: string
	initialSearchQuery?: string
}

const BlogSearch: FC<IBlogSearchProps> = ({placeholder, className, initialSearchQuery = ''}) => {
	const router = useRouter()
	const [searchQuery, setSearchQuery] = useState(initialSearchQuery)

	const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchQuery(e.target.value)
	}

	const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
		e.preventDefault()
		router.push(`/blog/search/${searchQuery}`)
	}

	return (
		<div className={cx('wrapper', className)}>
			<form onSubmit={handleSubmit} className={cx('form')}>
				<Button size="small" variant="primary" className={cx('btn')} type="submit">
					<IconSearch className={cx('icon')} />
				</Button>
				<Input
					value={searchQuery}
					onChange={(e) => onChangeSearch(e)}
					placeholder={placeholder}
					className={cx('input', 'search')}
					wrapperClassName={cx('input-wrapper')}
				/>
			</form>
		</div>
	)
}

BlogSearch.displayName = 'BlogSearch'

export default observer(BlogSearch)
